import { LocalizationService } from '@abp/ng.core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ca-vt-icon',
  templateUrl: './vt-icon.component.html',
  styleUrls: ['./vt-icon.component.scss', '../conversation-icons.scss'],
  standalone: false,
})
export class VtIconComponent implements OnInit {
  @Input()
  isVtActivated: boolean | null;

  get tooltip(): string {
    let result = '';

    if (this.isVtActivated) {
      result = `${this.localizationService.instant('Conversation::VtActivated')}`;
    }

    return result;
  }

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {}
}
